var exports = {
  "O": "xaee3c4fa--925df8--radio",
};

module.exports = exports;
